import React from 'react';

const Error = props => {
  return (
    <p>
      {props.errortext.message} errorStack: {props.errortext.stack}
    </p>
  );
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/error.js